import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import * as Types from 'types'
import { ExternalLink } from 'components'

const propTypes = {
  location: Types.location.isRequired,
  onClose: PropTypes.func.isRequired,
}

function PartnerPopup({ location, onClose }) {
  const locations = location.entries || [location]
  return (
    <div className="pop-up" data-cy="map-marker-pop-up">
      <button className="close" onClick={onClose} aria-label="Close popup">
        <span aria-hidden="true">×</span>
      </button>
      <div className="text-block">
        {locations.map((location) => {
          return (
            <div className="location" key={location.resourceId}>
              <h5 data-cy="map-marker-pop-up-name">
                <Link
                  to={
                    location.type === 'teaching_artist'
                      ? `/teaching-artist/${location.resourceId}`
                      : `/partners/${location.resourceId}`
                  }
                >
                  {location.name}
                </Link>
              </h5>
              <p>{location.address}</p>
              <div className="details">
                <ExternalLink
                  href={
                    location.type === 'teaching_artist'
                      ? `/teaching-artist/${location.resourceId}`
                      : `/partners/${location.resourceId}`
                  }
                  className="button-default-outline"
                >
                  {location.type === 'teaching_artist'
                    ? 'View Teaching Artist'
                    : 'View Partner'}
                </ExternalLink>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

PartnerPopup.propTypes = propTypes

export default PartnerPopup
